import React from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Field } from "formik";
import { useAppStore } from "../../../appStore";

export const PasswordFieldType = ({
  config,
  formik,
  setErrorState,
  stepNumber,
}: {
  config: any;
  formik: any;
  setErrorState: any;
  stepNumber: any;
}) => {
  const { userPermissions } = useAppStore();
  const [showPassword, setShowPassword] = React.useState(false);

  React.useEffect(() => {
    if (
      localStorage.copyValues === "true" &&
      localStorage.firstCameraAdded === "false" &&
      stepNumber === 1
    ) {
      const values = JSON.parse(localStorage.copiedValues);
      formik.values.password = values.password;
    }
    if (config.validation) {
      setErrorState((previousState: any) => {
        return { ...previousState, [config.id]: true };
      });
    }
  }, []);

  return (
    <div key={config.id}>
      <Field
        id={config.id}
        label={config.label}
        name={config.field}
        variant="standard"
        sx={{ width: 350 }}
        helperText={config.helperText}
        type={showPassword ? "text" : "password"}
        as={TextComponent}
        InputProps={
          userPermissions.view_passwords
            ? {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={
                        showPassword
                          ? "hide the password"
                          : "display the password"
                      }
                      onClick={() =>
                        setShowPassword((previousState) => !previousState)
                      }
                      onMouseDown={(event) => event.preventDefault()}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }
            : undefined
        }
      />
    </div>
  );
};

const TextComponent = (props: any) => <TextField {...props} />;
